// extracted by mini-css-extract-plugin
export default {"todoItem":"TodoItem_todoItem__Tvjk8"};